'use client'

import { createContext, useContext, useState } from 'react'

type ProductDetailProviderProps = {
  children: React.ReactNode
}
export type CommonTypeSelectedProduct = IVariantsProduct | undefined | null

const ProductDetailContext = createContext({productSelected: {} as CommonTypeSelectedProduct, setProductSelected: (data: CommonTypeSelectedProduct) => {}})

export const ProductDetailProvider = ({ children }: ProductDetailProviderProps) => {
  const [productSelected, setProductSelected] = useState<CommonTypeSelectedProduct>()

  return <ProductDetailContext.Provider value={{ productSelected, setProductSelected}}>{children}</ProductDetailContext.Provider>
}


export const useProductDetailState = () => {
  const productContext = useContext(ProductDetailContext)

  return {
    product: productContext?.productSelected,
    setProduct: productContext?.setProductSelected
  }
}
